import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./Auth/AuthProvider";
import PrivateRoute from "./Auth/ProtectedRoute";

import App from "./App";
import Register from "./Routes/Register";
import NewLogin from "./Routes/NewLogin";
import NewHome from "./Routes/NewHome";
import Colab from "./Routes/Colab";
import Treinamentos from "./Routes/Treinamentos";
import AuditoriaInterna from "./Routes/AuditoriaInterna";
import PlanejAuditInterna from "./Routes/PlanejAuditInterna";
import AuditoriaInternaId from "./Routes/AuditInternaId";
import AuditoriaCheck from "./Routes/AuditoriaCheck";
import RAC from "./Routes/RAC";
import Afastamentos from "./Routes/Afastamentos";
import Recisoes from "./Routes/Recisoes";
import ExamesOcupa from "./Routes/ExamesOcupa";
import FolhaPag from "./Routes/FolhaPag";
import Admissao from "./Routes/Admissao";
import NewReps from "./Routes/NewReps";
import FolgaCampo from "./Routes/FolgaCampo";
import UsersList from "./Routes/UsersList";
import InfoPanel from "./Routes/InfoPanel";
import GheFuncoes from "./Componentes/InfoPanel/GheFuncoes";
import ExamesGHE from "./Componentes/InfoPanel/ExamesGHE";
import TreinamentosGHE from "./Componentes/InfoPanel/TreinamentosGHE";
import CronogramTreinamentos from "./Routes/CronogramTreinamentos";
import GraficoContainer from "./Componentes/InfoPanel/GraficoContainer";
import Pendencias from "./Routes/Pendencias";
import EPIsHome from "./Routes/EPIsHome";
import EpiColab from "./Routes/EpiColab";
import PedidosEpi from "./Routes/PedidosEpi";
import EPIsInfo from "./Routes/EPIsInfo";
import EPIxFuncao from "./Routes/EPIxFuncao";
import UserAccess from "./Routes/UserAccess";
import ColabsOrg from "./Routes/ColabsOrg";
import ListaDDS from "./Routes/ListaDDS";
import ModuleSelector from "./Routes/ModuleSelector";
import PublicLayout from "./Routes/PublicLayout";
import CheckListHome from "./Routes/CheckListHome";
import CatalogoTreinamentos from "./Routes/CatalogoTreinamentos";
import FuncaoOS from "./Modulos/Treinamentos/funcao-os/FuncaoOS";
import Preview from "./Modulos/Treinamentos/cracha/Preview";
import NewAso from "./Routes/NewAso";
import NewRepublica from "./Routes/NewRepublica";
import ChecklistItens from "./Routes/ChecklistItens";
import ChecklistNcs from "./Routes/ChecklistNcs";
import Colaborador from "./Routes/Colaborador";
import Cipa from "./Routes/Cipa";
import CipaCandidatos from "./Routes/CipaCandidatos";
import CipaVotacao from "./Routes/CipaVotacao";
import ChecklistMetas from "./Routes/ChecklistMetas";
import Desvios from "./Routes/Desvios";
import ChecklistMyMetas from "./Routes/ChecklistMyMetas";
import DesviosMetas from "./Routes/DesviosMetas";
import Investigacoes from "./Routes/Investigacoes";
import Controladoria from "./Routes/Controladoria";
import EquipCalibracao from "./Routes/EquipCalibracao";
import ControleMedicaoAmb from "./Routes/ControleMedicaoAmb";
import PedidosCompra from "./Modulos/ControleMedicao/PedidosCompra/PedidosCompra";
import InfoPedidoCompra from "./Modulos/ControleMedicao/PedidosCompra/InfoPedidoCompra";
import PrevBoletim from "./Modulos/ControleMedicao/PrevisaoBoletim/PrevBoletim";
import BoletimMedicao from "./Modulos/ControleMedicao/BoletimMedicao/BoletimMedicao";
import InventarioTI from "./Routes/InventarioTI";

const router = createBrowserRouter([
  {
    // ROTAS PÚBLICAS
    element: <PublicLayout />,
    children: [
      { path: "/login", element: <NewLogin /> },
      { path: "/register", element: <Register /> },
    ],
  },
  {
    // ROTAS PROTEGIDAS
    element: <PrivateRoute />,
    children: [
      {
        element: <App />,
        children: [
          { path: "/", element: <ModuleSelector /> },
          { path: "/modules", element: <ModuleSelector /> },

          {
            element: <PrivateRoute requiredPermission={{ modulo: "rh" }} />,
            children: [
              { path: "/modulo/rh", element: <NewHome modulo="rh" /> },
              { path: "/modulo/rh/colaborador/:matricula", element: <Colaborador /> },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'afastamentos', funcao: 'access' }} />,
                children: [
                  { path: "/modulo/rh/afastamentos", element: <Afastamentos /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'controle-exp', funcao: 'access' }} />,
                children: [
                  { path: "/modulo/rh/controle-exp", element: <Recisoes /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'exames-ocupa', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/rh/exames-ocupa', element: <NewAso /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'folha-pag', funcao: 'access' }} />,
                children: [
                  { path: "/modulo/rh/folha-pag", element: <FolhaPag /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'ger-folgas', funcao: 'access' }} />,
                children: [
                  { path: 'modulo/rh/ger-folgas', element: <FolgaCampo /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'processo-adm', funcao: 'access' }} />,
                children: [
                  { path: "/modulo/rh/processo-adm", element: <Admissao /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'republicas', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/rh/republicas', element: <NewRepublica /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'rh', submodulo: 'organograma', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/rh/organograma-colabs', element: <ColabsOrg /> }
                ]
              }
            ]

          },

          // módulo SSMA

          {
            element: <PrivateRoute requiredPermission={{ modulo: "ssma" }} />,
            children: [
              { path: "/modulo/ssma", element: <NewHome modulo="ssma" /> },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', funcao: 'access_colab' }} />,
                children: [
                  { path: '/modulo/ssma/colaborador/:matricula', element: <Colaborador /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'auditoria-interna', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/auditoria-interna', element: <AuditoriaInterna /> },
                  { path: '/modulo/ssma/auditoria-interna/:id', element: <AuditoriaInternaId /> },
                  { path: '/modulo/ssma/planejamento-auditoria/:id', element: <PlanejAuditInterna /> },
                  { path: '/modulo/ssma/check-auditoria/:id', element: <AuditoriaCheck /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'cipa', funcao: 'access' }} />,
                children: [
                  { path: "/modulo/ssma/cipa", element: <Cipa /> },
                  { path: "/modulo/ssma/cipa/candidatos/:cc/:ano", element: <CipaCandidatos /> },
                  { path: "/modulo/ssma/cipa/votacao/:cc/:ano", element: <CipaVotacao /> },
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'dds', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/dds', element: <ListaDDS /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'epi', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/epi', element: <EPIsHome /> },
                  { path: '/modulo/ssma/epi/epi-colab/:matricula', element: <EpiColab /> },
                  { path: '/modulo/ssma/epi/epi-pedidos', element: <PedidosEpi /> },
                  { path: '/modulo/ssma/epi/epi-lista', element: <EPIsInfo /> },
                  { path: '/modulo/ssma/epi/epi-funcao', element: <EPIxFuncao /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'painel-ctrl', funcao: 'access' }} />,
                children: [
                  {
                    path: '/modulo/ssma/painel-ctrl', element: <InfoPanel />, children: [
                      { path: 'ghe-funcoes', element: <GheFuncoes /> },
                      { path: 'exames-ghe', element: <ExamesGHE /> },
                      { path: 'treinamentos-ghe', element: <TreinamentosGHE /> },
                      { path: "grafico-atend-amb", element: <GraficoContainer grafico="ATENDIMENTO AMBIENTAL" /> },
                      { path: "grafico-desvios", element: <GraficoContainer grafico="DESVIOS" /> },
                      { path: "grafico-insp-campo", element: <GraficoContainer grafico="INSPEÇÃO DE CAMPO" /> },
                      { path: "grafico-insp-ma", element: <GraficoContainer grafico="INSPEÇÃO DE MEIO AMBIENTE" /> },
                      { path: "grafico-treinamentos", element: <GraficoContainer grafico="TREINAMENTOS" /> },
                      { path: "grafico-rema", element: <GraficoContainer grafico="REMA" /> },
                    ]
                  }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'rac', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/rac/:id?', element: <RAC /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'treinamentos', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/treinamentos', element: <Treinamentos /> },
                  { path: '/modulo/ssma/treinamentos/form/:id?', element: <Treinamentos /> },
                  { path: '/modulo/ssma/treinamentos/new', element: <Treinamentos /> },
                  { path: '/modulo/ssma/treinamentos/view/:id', element: <Treinamentos /> },
                  { path: '/modulo/ssma/treinamentos/edit/:id', element: <Treinamentos /> },
                  { path: '/modulo/ssma/treinamentos/cronograma', element: <CronogramTreinamentos /> },
                  { path: "/modulo/ssma/treinamentos/catalogo", element: <CatalogoTreinamentos /> },
                  { path: "/modulo/ssma/treinamentos/catalogo/funcao-os", element: <FuncaoOS /> },
                  { path: "/preview/cracha", element: <Preview /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'check-list', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/check-list', element: <CheckListHome /> },
                  { path: '/modulo/ssma/check-list/:id', element: <ChecklistItens /> },
                  { path: '/modulo/ssma/check-list/metas', element: <ChecklistMetas /> },
                  { path: '/modulo/ssma/check-list/minhas-metas', element: <ChecklistMyMetas /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'check-list', funcao: 'view-nc' }} />,
                children: [
                  { path: '/modulo/ssma/check-list/nao-conformidades', element: <ChecklistNcs /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'organograma', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/organograma-colabs', element: <ColabsOrg /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'desvios', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/desvios', element: <Desvios /> },
                  { path: '/modulo/ssma/desvios/metas', element: <DesviosMetas /> },
                  { path: '/modulo/ssma/desvios/investigacao', element: <Investigacoes /> }
                ]
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'ssma', submodulo: 'equip-calibragem', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/ssma/equip-calibragem', element: <EquipCalibracao /> }
                ]
              }
            ]
          },
          {
            element: <PrivateRoute requiredPermission={{ modulo: 'gestao-acessos' }} />,
            children: [
              { path: "/modulo/gestao-acessos/", element: <UserAccess /> }
            ]
          },

          { path: "/pendencias", element: <Pendencias /> },

          //Modulo controladoria

          {
            element: <PrivateRoute requiredPermission={{ modulo: 'controladoria' }} />,
            children: [
              {
                path: "/modulo/controladoria/",
                element: <Controladoria />,
                children: [
                  {
                    element: <PrivateRoute requiredPermission={{ modulo: 'controladoria', submodulo: 'pedidos-compra', funcao: 'access' }} />,
                    children: [
                      { path: "/modulo/controladoria/pedidos-compra", element: <></> }
                    ]
                  }
                ]
              }
            ]
          },

          //Modulo Qualidade

          {
            element: <PrivateRoute requiredPermission={{ modulo: 'qualidade' }} />,
            children: [
              {
                path: "/modulo/qualidade",
                element: <NewHome modulo="qualidade" />,
              },
              {
                element: <PrivateRoute requiredPermission={{ modulo: 'qualidade', submodulo: 'equip-calibragem', funcao: 'access' }} />,
                children: [
                  { path: '/modulo/qualidade/equip-calibragem', element: <EquipCalibracao /> }
                ]
              }

            ]
          },

          {
            element: <PrivateRoute requiredPermission={{ modulo: 'controle-medicao' }} />,
            children: [
              {
                path: "/modulo/controle-medicao",
                element: <ControleMedicaoAmb />
              },
              {
                path: "/modulo/controle-medicao/pedidos-compra",
                element: <PedidosCompra />
              },
              {
                path: "/modulo/controle-medicao/pedidos-compra/:id",
                element: <InfoPedidoCompra />
              },
              {
                path: "/modulo/controle-medicao/pedidos-compra/:id/previsao-boletim",
                element: <PrevBoletim />
              },
              {
                path: "/modulo/controle-medicao/pedidos-compra/:id/boletins",
                element: <BoletimMedicao />
              }
            ]
          }
          ,
          {
            path: "/modulo/inventario-ti",
            element: <InventarioTI />
          }

        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);